var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import utils from '../utils.js';
import httpAdapter from './http.js';
import xhrAdapter from './xhr.js';
import fetchAdapter from './fetch.js';
import AxiosError from "../core/AxiosError.js";
var knownAdapters = {
    http: httpAdapter,
    xhr: xhrAdapter,
    fetch: fetchAdapter
};
utils.forEach(knownAdapters, function (fn, value) {
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', { value: value });
        }
        catch (e) {
            // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', { value: value });
    }
});
var renderReason = function (reason) { return "- ".concat(reason); };
var isResolvedHandle = function (adapter) { return utils.isFunction(adapter) || adapter === null || adapter === false; };
export default {
    getAdapter: function (adapters) {
        adapters = utils.isArray(adapters) ? adapters : [adapters];
        var length = adapters.length;
        var nameOrAdapter;
        var adapter;
        var rejectedReasons = {};
        for (var i = 0; i < length; i++) {
            nameOrAdapter = adapters[i];
            var id = void 0;
            adapter = nameOrAdapter;
            if (!isResolvedHandle(nameOrAdapter)) {
                adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) {
                    throw new AxiosError("Unknown adapter '".concat(id, "'"));
                }
            }
            if (adapter) {
                break;
            }
            rejectedReasons[id || '#' + i] = adapter;
        }
        if (!adapter) {
            var reasons = Object.entries(rejectedReasons)
                .map(function (_a) {
                var _b = __read(_a, 2), id = _b[0], state = _b[1];
                return "adapter ".concat(id, " ") +
                    (state === false ? 'is not supported by the environment' : 'is not available in the build');
            });
            var s = length ?
                (reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0])) :
                'as no adapter specified';
            throw new AxiosError("There is no suitable adapter to dispatch the request " + s, 'ERR_NOT_SUPPORT');
        }
        return adapter;
    },
    adapters: knownAdapters
};
